import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { createContext, useContext } from "react";

import Login from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AccountPage from "./pages/AccountPage";
import MapPage from "./pages/MapPage";
import GalleryPage from "./pages/GalleryPage";
import ProjectSelectionPage from "./pages/ProjectSelectionPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import PublicMapPage from "./pages/PublicMapPage";
import AiChatPage from "./pages/AiChatPage";

import Logout from "./features/accounts/components/Logout";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import ToastContainer from "./components/ToastContainer";
import { useToast } from "./hooks/useToast";
import { AuthProvider } from "./features/accounts/contexts/AuthContext";

import "./App.css";

export const ToastContext = createContext();
export const useToastContext = () => useContext(ToastContext);

function App() {
    const toast = useToast();
    return (
        <AuthProvider>
            <ToastContext.Provider value={toast}>
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/logout" element={<Logout />} />

                            {/* 公開用ルート */}
                            <Route path="/public/:publicUrl" element={<PublicMapPage />} />

                            <Route path="/dashboard/*" element={<ProtectedRoute />}>
                                <Route element={<DashboardLayout />}>
                                    <Route index element={<ProjectSelectionPage />} />
                                    <Route path="select" element={<Navigate to="/dashboard" replace />} />
                                    <Route path="account" element={<AccountPage />} />

                                    <Route path=":projectId" element={<DashboardPage />}>
                                        <Route path="detail" element={<ProjectDetailPage />} />
                                        <Route path="account" element={<AccountPage />} />
                                        <Route path="map" element={<MapPage />} />
                                        <Route path="gallery" element={<GalleryPage />} />
                                        <Route path="ai" element={<AiChatPage />} />
                                        <Route index element={<Navigate to="account" replace />} />
                                    </Route>
                                </Route>
                            </Route>

                            <Route path="*" element={<Navigate to="/login" replace />} />
                        </Routes>
                    </BrowserRouter>
                    <ToastContainer />
                </div>
            </ToastContext.Provider>
        </AuthProvider>
    );
}

export default App;
